import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Matthias macht gerne Wissenschaftliches und Denksport, ist aber auch an Darts und Formel 1 interessiert. Und natürlich an Sprachen. Was er nicht mag sind wirtschaftliche und juristische Fragen, laute Geräusche, sowie wenn seine Pläne und Ideen nicht aufgehen. '
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'das-project-foto-matthias1_pnbf22',
    alt: 'dasProject Foto Matthias',
    aspectRatio: 0.66666
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'das-project-foto-matthias4_pguavc',
    alt: 'dasProject Foto Matthias',
    aspectRatio: 0.66666
  },
  {
    type: 'group',
    position: 'left',
    text: 'Matthias\' Motto: Nur durch Wissen über die Welt und den Weg der Wahrheit findet man am Ziel Erkenntnis.',
    firstImg: {
      id: 'das-project-foto-matthias5_kx8t66',
      alt: 'dasProject Foto Matthias',
      aspectRatio: 0.66666
    },
    secondImg: {
      id: 'das-project-foto-matthias2_tmighq',
      alt: 'dasProject Foto Matthias',
      aspectRatio: 0.66666
    }
  },
  {
    type: 'text',
    text: 'Fun Fact : Einerseits ist Matthias zwar bei Denkspiel oder auch Sudoku so gut, dass er eigentlich schon Rekorde brechen könnte (oder es sogar hat), kann aber im Alltag vieles Selbstverständliche nicht. Zum Beispiel Schuhe binden, Wäsche waschen, …'
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'das-project-foto-matthias3_usrlvi',
    alt: 'dasProject Foto Matthias',
    aspectRatio: 0.66666
  }
]

const color = 'red'

export default class ReactComponent extends React.Component {
  constructor(){
    super()
    this.state = {color: 'red'}
  }

  render () {
    return (
      <div>
        <Person content={content} color={this.state.color} name='Matthias' next={3} previous={1}/>
      </div>
    )
  }
}

exports.data = {
  color: 'red',
  number: 3
}



// WEBPACK FOOTER //
// ./matthias.js